// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2l2yD","col":"styles_col__1nZFq"};